<script setup lang="ts">
import { useApp } from '../stores/app';
import Icon from './Icon.vue';

const app = useApp();
</script>

<template>
  <div class="toasts" role="status" aria-live="polite">
    <div v-for="t in app.toasts" :key="t.id" class="toast" :class="t.level">
      <Icon :name="t.level === 'info' ? 'info' : 'warning'" :size="16" />
      <span>{{ t.message }}</span>
      <button v-for="(a, i) in t.actions ?? []" :key="i" class="toast-action" @click="(app.dismiss(t.id), a.run())">{{ a.label }}</button>
      <button class="icon-btn" :aria-label="'×'" @click="app.dismiss(t.id)"><Icon name="close" :size="14" /></button>
    </div>
  </div>
</template>

<style scoped>
.toast-action {
  flex: none;
  height: 26px;
  padding: 0 10px;
  border: 1px solid rgba(248, 250, 252, 0.35);
  border-radius: var(--radius-control);
  background: transparent;
  color: inherit;
  font: inherit;
  font-size: 12.5px;
  cursor: pointer;
}
.toast-action:hover {
  background: rgba(248, 250, 252, 0.12);
}
.toasts {
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 3000;
  pointer-events: none;
}
.toast {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 280px;
  max-width: 560px;
  padding: 6px 6px 6px 12px;
  background: #0f172a;
  color: #f8fafc;
  border-radius: var(--radius-panel);
  box-shadow: var(--shadow);
}
.toast span {
  flex: 1;
}
.toast.warning {
  background: #78350f;
}
.toast.error {
  background: #7f1d1d;
}
.toast .icon-btn {
  color: inherit;
  width: 26px;
  height: 26px;
}
</style>
